
    import * as React from 'react';

    const ShoppingBag20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="ShoppingBag_20_svg__Icons/Shopping-Bag/20" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M2,18 L2,8 L7,8 L7,5 C7,3.34314575 8.34314575,2 10,2 C11.6568542,2 13,3.34314575 13,5 L13,8 L18,8 L18,18 L13,18 L7,18 L2,18 Z M7,9 L3,9 L3,17 L7,17 L7,9 Z M12,9 L8,9 L8,17 L12,17 L12,9 Z M17,9 L13,9 L13,17 L17,17 L17,9 Z M10,3 C8.8954305,3 8,3.8954305 8,5 L8,8 L12,8 L12,5 C12,3.8954305 11.1045695,3 10,3 Z" id="ShoppingBag_20_svg__Combined-Shape" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    ShoppingBag20.displayName = 'ShoppingBag20';

    export default ShoppingBag20;
  